import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';

import OfficialPage from '../OfficialPage';

import './CheckRowNumberDetail.less';

import { TopNav } from '@common/top-nav/TopNav';

export default class CheckRowNumberDetail extends OfficialPage {
  state = {
    orderData: '',
    orderInfo: '',
    userInfo: ''
  }
  orderId = ''
  franchiseeId = ''

  constructor(props) {
    super(props);
    document.title = '保存号单';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
    this.franchiseeId = options.franchiseeId
    this.dataInitial()
  }

  dataInitial = () => {
    this.getOrderDetail()
    this.getTostoreSetting()
    this.setData({
      userInfo: app.getUserInfo()
    })
  }
  getOrderDetail = () => {
    let that = this
    app.getOrderDetail({
      data: {
        order_id: that.orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        let data = res.data[0]
        that.setData({
          orderData: data,
          orderInfo: data.form_data
        })
      }
    })
  }
  getTostoreSetting = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      success: function (res) {
        if (res.status == 0) {
          _this.setData({
            toStoreSetting: res.data
          })
        }
      }
    })
  }

  render() {
    const { orderInfo, toStoreSetting, userInfo } = this.state
    return (
      <div className="official-page check-row-number-detail">
        <TopNav title="保存单号" />
        <div className="shop-setting">
          <img src={orderInfo.app_info && orderInfo.app_info.app_logo} />
            <span className="shop-name">{orderInfo.app_info && orderInfo.app_info.app_name}</span>
        </div>
          <div className="row-num-content-box">
            <div className="row-num-content">
              <div className="people-icon"></div>
              <div className="top-background"></div>
              <div className="take-num-content">
                <div className="row-number-title" style={{fontSize: (orderInfo.line_up_data && orderInfo.line_up_data.line_up_type_data.name.length > 3)  ? '.60rem' : null}}>
                  {(orderInfo.line_up_data && orderInfo.line_up_data.line_up_type_data.name +
                    orderInfo.line_up_data.queue_num_name) || ''}
                </div>
                <div className="row-number-wait">
                  <span className="line"></span>
                  {(orderInfo.line_up_data && orderInfo.line_up_data.prepare_wait_time) > 0
                    ? '等待时间' +
                    (orderInfo.line_up_data.prepare_wait_time >
                      toStoreSetting.max_display_time
                      ? ' >' + toStoreSetting.max_display_time
                      : orderInfo.line_up_data.prepare_wait_time) +
                    'min'
                    : '无需等待'}
                  <span className="line"></span>
                </div>
              </div>
              <div className="add-time">
                <span className="ico-moon icon-row-number-wait"></span>
                {'取号时间： ' + (orderInfo.add_time || '')}
              </div>
            </div>
            <div className="avatar">
              <img src={userInfo.cover_thumb} />
          </div>
            </div>
            <div className="dividing-line-box">
              <span className="tip-line"></span>
              <span className="tip-square"></span>
              <span className="tip-line"></span>
            </div>
            <div className="shop-tip">{toStoreSetting && toStoreSetting.additional_info && toStoreSetting.additional_info.info}</div>
          </div>
          )
        }
      }



// WEBPACK FOOTER //
// ./src/official-page/check-row-number-detail/CheckRowNumberDetail.jsx